var path = 'audit/audit-logs.tpl.html';
var html = "\n<tb-audit-log-table class=\"md-whiteframe-z1\" flex audit-log-mode=\"{{vm.types.auditLogMode.tenant}}\" page-mode=\"true\">\n</tb-audit-log-table>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/audit/audit-logs.tpl.html
// module id = 1388
// module chunks = 1